import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLayerlist = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M19.9951 10.2551L13.2351 15.5151C12.5151 16.0851 11.4951 16.0851 10.7751 15.5251L4.01506 10.2651C3.50506 9.86512 3.50506 9.08512 4.01506 8.68512L10.7751 3.41512C11.5051 2.85512 12.5151 2.85512 13.2351 3.41512L19.9951 8.67512C20.5051 9.07512 20.5051 9.85512 19.9951 10.2551ZM11.3751 18.5351C11.7351 18.8151 12.2451 18.8151 12.6051 18.5351L18.7551 13.7451C19.1135 13.4651 19.6166 13.4651 19.9751 13.7451L19.9851 13.7551C20.4951 14.1551 20.4951 14.9251 19.9851 15.3251L13.2251 20.5851C12.4951 21.1451 11.4851 21.1451 10.7651 20.5851L4.00506 15.3251C3.49506 14.9251 3.49506 14.1551 4.00506 13.7551C4.36353 13.4751 4.86658 13.4751 5.22506 13.7551L11.3751 18.5351Z",
		fill: "currentColor"
	})
});
export default SvgLayerlist;
